import React, { useState, useEffect, useContext } from 'react';
import { apiRequest } from '../api';
import { AuthContext } from '../context/AuthContext';
import './Tasks.css';
import API_BASE_URL from '../apiConfig';
import { commonIcons } from './assetImports';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n/config';

const TasksPage = ({ wallets, setWallets, isTelegramMiniApp }) => {
    const { t } = useTranslation('tasks');
    const { user } = useContext(AuthContext);
    const [tasks, setTasks] = useState([]);
    const [claimSuccessPopup, setClaimSuccessPopup] = useState(false);

    const filteredTasks = tasks.filter(task => {
        if (isTelegramMiniApp) {
          return task.currency === 'token' || task.currency === 'stars';
        } else {
          return task.currency === 'token' || task.currency === 'usdt';
        }
      });
   useEffect(() => {
  i18n.loadNamespaces(['tasks'], () => {

  });
}, []);
    useEffect(() => {
        const fetchTasks = async () => {
            try {
                const response = await apiRequest(`${API_BASE_URL}/api/tasks`, {
                    method: 'GET',
                    credentials: 'include',
                });

                const data = await response.json();
                if (response.ok) {
                
                    setTasks(data.tasks.filter(task => !task.completed));
                } else {
                    console.error('Failed to fetch tasks:', data.message);
                }
            } catch (error) {
                console.error('Error fetching tasks:', error);
            }
        };

        fetchTasks();
    }, []);

    const handleClaimTaskReward = async (taskId) => {
        try {
          const response = await apiRequest(`${API_BASE_URL}/api/claim-task-reward`, {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ taskId }),
          });
      
          const data = await response.json();
          if (response.ok) {
            triggerConfettiAnimation();
      
            // Update wallets
            setWallets(prev => ({
              ...prev,
              [data.reward.currency]: (prev[data.reward.currency] || 0) + data.reward.amount
            }));
           
            setClaimSuccessPopup({
                isVisible: true,
                isError: false,
                amount: data.reward.amount,
                currency: data.reward.currency
              });
      
            // Remove claimed task from display
            setTasks(prev => prev.filter(task => task._id !== taskId));
      
          } else {
            console.error('Failed to claim task reward:', data.message);
            setClaimSuccessPopup({
                isVisible: true,
                isError: true,
                message: "Something went wrong."
              });
          }
        } catch (error) {
          console.error('Error claiming task reward:', error);
        }
      };
      

    const triggerConfettiAnimation = () => {
        const confettiContainer = document.createElement('div');
        confettiContainer.className = 'confetti-container';
    
        for (let i = 0; i < 250; i++) {
            const confetti = document.createElement('div');
            confetti.className = 'confetti-piece';
            
            confetti.style.left = '50%';
            confetti.style.top = '50%';
            confetti.style.backgroundColor = `hsl(${Math.random() * 360}, 100%, 50%)`;
            confetti.style.transform = `rotate(${Math.random() * 360}deg)`;

            const randomX = (Math.random() - 0.5) * window.innerWidth * 2;
            const randomY = (Math.random() - 0.5) * window.innerHeight * 2;
            const duration = Math.random() * 1.4 + 0.8;

            confetti.style.animation = `explode ${duration}s ease-out forwards`;
            confetti.style.setProperty('--randomX', `${randomX}px`);
            confetti.style.setProperty('--randomY', `${randomY}px`);

            confettiContainer.appendChild(confetti);
        }

        document.body.appendChild(confettiContainer);

        setTimeout(() => {
            document.body.removeChild(confettiContainer);
        }, 4000);
    };

    const handleClosePopup = () => {
        setClaimSuccessPopup({ isVisible: false });
    };

   const getProgressText = (task) => {

    const dailyStats = user.dailyGameStats || {
        tokenGamesPlayed: 0,
        starsGamesPlayed: 0,
        usdtGamesPlayed: 0
    };

    switch(task.condition) {
        case 'invite_20_friends':
            return t('progress.invite_friends', { 
                count: user.invitedFriends?.length || 0, 
                total: 20 
            });

            case 'invite_a_friend':
            return t('progress.invite_a_friend', { 
                count: user.invitedFriends?.length || 0, 
                total: 1 
            });
            
        case 'win_100_games':
            return t('progress.win_games', { 
                count: user.wins || 0, 
                total: 100 
            });
            
        case 'daily_checkin':
            return t('progress.ready_to_claim');
            
        case 'play_10_token_games_daily':
            return t('progress.play_token_games', { 
                count: dailyStats.tokenGamesPlayed, 
                total: 10 
            });
            
        case 'play_10_stars_games_daily':
            return t('progress.play_stars_games', { 
                count: dailyStats.starsGamesPlayed, 
                total: 10 
            });
            
        case 'play_10_usdt_games_daily':
            return t('progress.play_usdt_games', { 
                count: dailyStats.usdtGamesPlayed, 
                total: 10 
            });
            
        default:
            console.warn('Unknown task condition:', task.condition);
            return '';
    }
};

const getRewardIcon = (currency) => {
  switch (currency) {
    case 'stars':
      return <img src={commonIcons.starIcon} alt="Star" className="reward-icon" />;
    case 'token':
      return <img src={commonIcons.tokenYellow} alt="Token" className="token-reward-icon" />;
    default:
      return <img src={commonIcons.usdtIcon} alt="USDT" className="reward-icon" />;
  }
};

    return (
        <div className="tasks-page-container">
            <h1 className="tasks-page-title">{t('page_title')}</h1>
            
            <div className="tasks-list">
                {filteredTasks.length > 0 ? (
                    filteredTasks.map((task) => (
                        <div 
                            key={task._id} 
                            className="base-item-box task-animate-in"
                            onClick={() => task.conditionMet && handleClaimTaskReward(task._id)}
                        >
                            <div className="base-item-content">
                                <div className="task-info">
                                    <h4 className="task-name">{t(task.name)}</h4>
                                    <p className="task-status">{getProgressText(task)}</p>
                                </div>
                                <div className={`task-reward ${!task.conditionMet ? 'not-ready' : ''}`}>
                                    <span className="reward-amount">{task.reward}</span>
                                    {getRewardIcon(task.currency)}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="no-tasks-message">{t('no_tasks')}</p>
                )}
            </div>

            {claimSuccessPopup.isVisible && (
  <>
    <div className="task-popup-overlay" onClick={handleClosePopup}></div>

    <div className="task-reward-popup" onClick={(e) => e.stopPropagation()}>
      <div className="task-screen-blur"></div>
      <div className="task-popup-background"></div>

      <div className="task-popup-content">
      {claimSuccessPopup.isError ? (
          <>
            <div className="task-popup-error-message">{t(claimSuccessPopup.message)}</div>
            <button className="task-close-btn" onClick={handleClosePopup}>
              Close
            </button>
          </>
        ) : (
          <>
            <h3 className="task-popup-title">{t('reward_claimed')}</h3>

            <div className="task-points-center">
              <span className="task-points-value">+{claimSuccessPopup.amount}</span>
              <div
                className="task-reward-icon"
                style={{
                  backgroundImage:
                    claimSuccessPopup.currency === 'stars'
                      ? `url(${commonIcons.starIcon})`
                      : claimSuccessPopup.currency === 'token'
                      ? `url(${commonIcons.tokenYellow})`
                      : `url(${commonIcons.usdtIcon})`,
                }}
              />
            </div>

            <button className="task-close-btn" onClick={handleClosePopup}>{t('close')}</button>
          </>
        )}
      </div>
    </div>
  </>
)}



        </div>
    );
};

export default TasksPage;